/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pr_Type_HeightInputs */

const fr_pr_type_height = /** @type {(inputs: Pr_Type_HeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hauteur`)
};

/**

* @param {Pr_Type_HeightInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const pr_type_height = /** @type {((inputs?: Pr_Type_HeightInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pr_Type_HeightInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_pr_type_height(inputs)
});